import {createStore, applyMiddleware, compose} from 'redux';
import {createLogger} from 'redux-logger';
import analytics from '../middleware/analytics';
import promise from '../middleware/promise';
import {isClient, isDebug} from '../../common/configs/index';

import rootReducer from '../reducers';

const configureStore = initialState => {
  const middleware = [analytics, promise];
  let store;

  if (isClient && isDebug) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    middleware.push(
      createLogger({
        collapsed: true
      })
    );

    const enhancer = composeEnhancers(applyMiddleware(...middleware));

    store = createStore(rootReducer, initialState, enhancer);
  } else {
    store = createStore(rootReducer, initialState, compose(applyMiddleware(...middleware)));
  }

  if (module.hot) {
    module.hot.accept('reducers', () => {
      // eslint-disable-next-line global-require
      const nextReducer = require('./../reducers');

      store.replaceReducer(nextReducer);
    });
  }

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./store/configureStore.jsx